"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.ScreenP2PRemindYourPropertyAnalyticsEvent = exports.ScreenP2PPropertySetupStartAnalyticsEvent = exports.ScreenP2PPropertyFinishedSignupAnalyticsEvent = exports.ScreenP2PPropertyConfirmAnalyticsEvent = exports.ScreenP2PInviteYourPropertyAnalyticsEvent = exports.ScreenP2PHowItWorksAnalyticsEvent = exports.P2PRemindYourPropertySendCtaClickedAnalyticsEvent = exports.P2PRemindYourPropertyLaterCtaClickedAnalyticsEvent = exports.P2PPropertySetupStartCtaClickedAnalyticsEvent = exports.P2PPropertyFinishedSignupGenericCtaClickedAnalyticsEvent = exports.P2PPropertyConfirmResendCtaClickedAnalyticsEvent = exports.P2PPropertyConfirmPortalClickAnalyticsEvent = exports.P2PInviteYourPropertyShareClickedAnalyticsEvent = exports.P2PInviteYourPropertyCtaClickedAnalyticsEvent = exports.P2PInviteYourPropertyCopyClickedAnalyticsEvent = exports.P2PHowItWorksCtaClickedAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when user lands on the P2P How It Works screen in the Onboarding Flow
 */
var ScreenP2PHowItWorksAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_P2P_how_it_works');
exports.ScreenP2PHowItWorksAnalyticsEvent = ScreenP2PHowItWorksAnalyticsEvent;
/**
 * Triggers when user clicks continue button on the P2P How It Works screen in the Onboarding Flow
 */
var P2PHowItWorksCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('P2P_how_it_works_cta_clicked');
exports.P2PHowItWorksCtaClickedAnalyticsEvent = P2PHowItWorksCtaClickedAnalyticsEvent;
/**
 * Triggers when user lands on the P2P Property Setup Start screen in the Onboarding Flow
 */
var ScreenP2PPropertySetupStartAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_P2P_property_setup_start');
exports.ScreenP2PPropertySetupStartAnalyticsEvent = ScreenP2PPropertySetupStartAnalyticsEvent;
/**
 * Triggers when user clicks continue button on the P2P Property Setup Start screen in the Onboarding Flow
 */
var P2PPropertySetupStartCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('P2P_property_setup_start_cta_clicked');
exports.P2PPropertySetupStartCtaClickedAnalyticsEvent = P2PPropertySetupStartCtaClickedAnalyticsEvent;
/**
 * Triggers when user lands on the P2P Invite Your Property screen in the Onboarding Flow
 */
var ScreenP2PInviteYourPropertyAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_P2P_invite_your_property');
exports.ScreenP2PInviteYourPropertyAnalyticsEvent = ScreenP2PInviteYourPropertyAnalyticsEvent;
/**
 * Triggers when user clicks share button on the P2P Invite Your Property screen in the Onboarding Flow
 */
var P2PInviteYourPropertyShareClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('P2P_invite_your_property_share_clicked');
exports.P2PInviteYourPropertyShareClickedAnalyticsEvent = P2PInviteYourPropertyShareClickedAnalyticsEvent;
/**
 * Triggers when user clicks copy button on the P2P Invite Your Property screen in the Onboarding Flow
 */
var P2PInviteYourPropertyCopyClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('P2P_invite_your_property_copy_clicked');
exports.P2PInviteYourPropertyCopyClickedAnalyticsEvent = P2PInviteYourPropertyCopyClickedAnalyticsEvent;
/**
 * Triggers when user clicks "Ive invited them" button on the P2P Invite Your Property screen in the Onboarding Flow
 */
var P2PInviteYourPropertyCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('P2P_invite_your_property_cta_clicked');
exports.P2PInviteYourPropertyCtaClickedAnalyticsEvent = P2PInviteYourPropertyCtaClickedAnalyticsEvent;
/**
 * Triggers when user lands on the P2P Remind Your Property screen in the Onboarding Flow
 */
var ScreenP2PRemindYourPropertyAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_P2P_remind_your_property');
exports.ScreenP2PRemindYourPropertyAnalyticsEvent = ScreenP2PRemindYourPropertyAnalyticsEvent;
/**
 * Triggers when user clicks "Send" button on the P2P Remind Your Property screen in the Onboarding Flow
 */
var P2PRemindYourPropertySendCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('P2P_remind_your_property_send_cta_clicked');
exports.P2PRemindYourPropertySendCtaClickedAnalyticsEvent = P2PRemindYourPropertySendCtaClickedAnalyticsEvent;
/**
 * Triggers when user clicks "Later" button on the P2P Remind Your Property screen in the Onboarding Flow
 */
var P2PRemindYourPropertyLaterCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('P2P_remind_your_property_later_cta_clicked');
exports.P2PRemindYourPropertyLaterCtaClickedAnalyticsEvent = P2PRemindYourPropertyLaterCtaClickedAnalyticsEvent;
/**
 * Triggers when user lands on the P2P Property Confirm screen in the Onboarding Flow
 */
var ScreenP2PPropertyConfirmAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_P2P_property_confirm');
exports.ScreenP2PPropertyConfirmAnalyticsEvent = ScreenP2PPropertyConfirmAnalyticsEvent;
/**
 * Triggers when user clicks "Portal" button on the P2P Property Confirm screen in the Onboarding Flow
 */
var P2PPropertyConfirmPortalClickAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('P2P_property_confirm_portal_click');
exports.P2PPropertyConfirmPortalClickAnalyticsEvent = P2PPropertyConfirmPortalClickAnalyticsEvent;
/**
 * Triggers when user clicks "Resend" button on the P2P Property Confirm screen in the Onboarding Flow
 */
var P2PPropertyConfirmResendCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('P2P_property_confirm_resend_cta_clicked');
exports.P2PPropertyConfirmResendCtaClickedAnalyticsEvent = P2PPropertyConfirmResendCtaClickedAnalyticsEvent;
/**
 * Triggers when user lands on the P2P Property Finished Signup screen in the Onboarding Flow
 */
var ScreenP2PPropertyFinishedSignupAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_P2P_property_finished_signup');
exports.ScreenP2PPropertyFinishedSignupAnalyticsEvent = ScreenP2PPropertyFinishedSignupAnalyticsEvent;
/**
 * Triggers when user clicks "Continue" button on the P2P Property Finished Signup screen in the Onboarding Flow
 */
var P2PPropertyFinishedSignupGenericCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('P2P_property_finished_signup_generic_cta_clicked');
exports.P2PPropertyFinishedSignupGenericCtaClickedAnalyticsEvent = P2PPropertyFinishedSignupGenericCtaClickedAnalyticsEvent;
